import styled from 'styled-components';
export const StyledMenuButton = styled.button`
  background-color: ${(props) => props.selected ? props.theme.menuItemSelected_BG : props.theme.menuItem_BG} !important;
  color: ${(props) => props.selected ? props.theme.menuItemSelected_text : props.theme.menuItem_text} !important;
  @media (max-width: 580px) {
    &:hover {
      background-color: ${(props) => props.selected ? props.theme.menuItemSelected_BG : props.theme.menuItem_BG};
      color: ${(props) => props.selected ? props.theme.menuItemSelected_text : props.theme.menuItem_text};
    }
  }
  @media (min-width: 580px) {
    &:hover {
      background-color: ${(props) => props.selected ? props.theme.menuItemSelected_BG : props.theme.menuItem_BG} !important;
      color: ${(props) => props.selected ? props.theme.menuItemSelected_text : props.theme.menuItem_text} !important;
    }
  }
`;

export const StyledMenuSelect = styled.select`
  background-color: ${(props) => props.theme.dropdownSelect_BG} !important;
  color: ${(props) => props.theme.dropdownSelect_text} !important;
`;

export const StyledMenuOption = styled.option`
  background-color: ${(props) => props.theme.dropdownOption_BG} !important;
  color: ${(props) => props.theme.dropdownOption_text} !important;
`;